    <app-public-header-layout></app-public-header-layout>
    
<div class="public-layout">

    <!-- =========================================================
         HEADER
    ========================================================== -->



    <!-- =========================================================
         PAGE CONTENT
    ========================================================== -->
    <main class="layout-content">
        <router-outlet></router-outlet>
    </main>

</div>

<app-public-footer-layout></app-public-footer-layout>